module.exports = __webpack_public_path__ + "img/nba-newhires.8c04d7e3.jpg";